export const getTabs = (_status: string, _PO: string = null) => ([
    { id: 'MovementEnquiryDetails', label: 'Movement Details', disabled: false},
    { id: 'Transactions', label: 'Transactions', disabled: false },
    { id: 'BinLocations', label: 'Bin Locations', disabled: false },
    { id: 'LotDetails', label: 'Lot Details', disabled: false },
    { id: 'SerialNumbers', label: 'Serial Numbers', disabled: false }
]);

export const MovementEnquiryCalculationFields = ['OrderedQuantity', 'BackorderedQuantity', 'BuyingUnit', 'Price', 'BasePrice', 'Discount'];
export const MovementEnquiryDetailsCalculationFields = ['Supplier', 'OrderType', 'MovementEnquiryCategory', 'EarliestDueDate'];
export const MovementEnquiryDeliveryCalculationFields = ['SiteCode', 'FreightCode', 'Warehouse'];
export const DisabledSearchLookUpDrawerTabs = ['LineDetails', 'Commit', 'MovementEnquiryLineCommitments'];
export const DisabledChangeStatus = ['LineDetails', 'Commit', 'MovementEnquiryLineCommitments', 'MovementEnquiryDiary', 'MovementEnquiryDiaryDetails', 'MovementEnquiryNotepad'];
